/**
 * @module
 * @format
 */

/**
 * @import {Controller} from '@acng/frontend-stargazer';
 * @import {ImageFormat} from '../ts/core/image.ts';
 */

import {REACTIVE} from '@acng/frontend-stargazer';
import {ENUM, guard, OBJECT, OPTIONAL, STRING} from '@acng/frontend-rubicon';

/**
 * @typedef {{base: string; hash?: string}} FriggImageData
 */

export const POSSIBLE_IMAGE_FORMATS = /** @type {const} */ ([
  '160',
  '300',
  '320',
  '400',
  '500',
  '600',
  '800',
  '900',
  '1000',
  '1200',
  'large',
  'small',
  'svga',
  'xsignup',
  'mini',
  'th',
  'thumb',
  'fsk',
  'status',
  'pw',
  'avatar',
  'sm',
  'medium',
  'preview',
  'portrait',
  'xl',
  'xxl',
  'xga',
]);

export const IMAGE_FORMAT = /* @__PURE__ */ ENUM(POSSIBLE_IMAGE_FORMATS);

const FRIGG_IMAGE_DATA = /* @__PURE__ */ OBJECT({
  base: STRING,
  hash: /* @__PURE__ */ OPTIONAL(STRING),
});

export const IMAGE_DATA = /* @__PURE__ */ OBJECT({
  url: STRING,
  frigg: FRIGG_IMAGE_DATA,
});

/**
 * @type {ProxyHandler<{getImageUrl: (format?: ImageFormat) => string}>}
 */
const proxyHandler = {
  has(_target, key) {
    return key != 'then' && key != REACTIVE;
  },
  get(target, key) {
    if (key == 'then' || key == REACTIVE) {
      return undefined;
    }

    ASSERT: guard(key, IMAGE_FORMAT);
    const imageUrl = target.getImageUrl(key);

    return imageUrl;
  },
};

/**
 * @template {{getImageUrl: (format?: ImageFormat) => string}} T
 * @param {(format?: ImageFormat) => string} _
 * @param {ClassMethodDecoratorContext<T & Controller<T>, (format?: ImageFormat) => string>} context
 * @group Decorator
 */
const frigg = (_, {name, addInitializer}) => {
  addInitializer(function () {
    const that = this;
    that[REACTIVE] ??= {};
    that[REACTIVE][name] = new Proxy(that, proxyHandler);
  });
};

export {frigg};
